// Cari Grup Yönetimi penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'accounts.groups';

export const accountGroupsGuide = (t: TFunction): GuideContent => ({
  layout: 'split',
  // Gerçek ekranda form solda, grup listesi sağda
  mirror: true,
  title: t(`${G}.title`, 'Cari grupları nasıl yönetilir?'),
  intro: t(`${G}.intro`, 'Cari grupları, cari hesapları düzenli bir sınıflamayla takip etmenizi sağlar. Doğru grup yapısı raporlamayı ve günlük işleri hızlandırır.'),
  regionLabels: {
    list: t(`${G}.regions.list`, 'Mevcut cari grupları'),
    form: t(`${G}.regions.form`, 'Grup ekleme formu'),
  },
  steps: [
    {
      region: 'list',
      title: t(`${G}.s1.title`, '1. Grup yapısını tanıyın'),
      text: t(`${G}.s1.text`, '"Mevcut Cari Grupları" tablosu ana grupları ve altlarındaki alt grupları girintili gösterir. Alt grubu olan satırdaki ok ile grubu açıp kapatabilirsiniz.'),
      tips: [
        t(`${G}.s1.tip1`, 'En fazla 3 seviye desteklenir (ana grup + 2 alt seviye). Bu sınır yapının karmaşıklaşmasını önler.'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s2.title`, '2. Ana grup ekleyin'),
      text: t(`${G}.s2.text`, 'Hiçbir grup seçili değilken form "Yeni Ana Grup Ekle" olarak açılır. İsterseniz şube seçin, grup adını yazın ve "Grubu Ekle"ye basın.'),
      tips: [
        t(`${G}.s2.tip1`, 'Seçilen şube, grubun hangi şubeye ait olacağını belirler. Şube seçmezseniz grup "Genel" olur.'),
        t(`${G}.s2.tip2`, 'Şube müdürüyseniz şube kendi şubeniz olarak sabittir.'),
        t(`${G}.s2.tip3`, 'Ana grupları, raporda ayrı takip etmek istediğiniz büyük iş kategorileri için açın.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s3.title`, '3. Alt grup için üst grubu seçin'),
      text: t(`${G}.s3.text`, 'Tablodaki bir satıra ya da satırdaki + simgesine tıklayın. Form o grubun altına alt grup ekleyecek şekilde değişir.'),
      tips: [
        t(`${G}.s3.tip1`, 'Alt grupları, aynı ana kategori içindeki farklı müşteri / iş modeli kırılımlarını ayırmak için kullanın.'),
        t(`${G}.s3.tip2`, '3. seviyedeki bir gruba alt grup eklenemez; formda uyarı görünür.'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s4.title`, '4. Alt grubu kaydedin'),
      text: t(`${G}.s4.text`, 'Grup adını yazıp "Alt Grup Ekle"ye basın. Alt grubun şubesi üst gruptan otomatik alınır, değiştirilemez; böylece hiyerarşi tutarlı kalır. Vazgeçmek için "Seçimi Temizle"ye basın.'),
    },
    {
      region: 'list',
      title: t(`${G}.s5.title`, '5. Grup silme kuralları'),
      text: t(`${G}.s5.text`, 'Satırdaki çöp kutusu simgesi grubu siler.'),
      tips: [
        t(`${G}.s5.tip1`, 'Alt grubu olan bir grup doğrudan silinemez; önce alt grupları silin.'),
        t(`${G}.s5.tip2`, 'Sistem için zorunlu temel gruplar (ör. "Genel Cari Grubu") silinemez; bu, veri bütünlüğünü korur.'),
      ],
    },
  ],
});
